import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { DoctorTableModal } from "../../types/doctorTable/DoctorTableModal";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";

interface DoctorTableState {
  doctorTableLoading: boolean;
  doctorTableSuccess: boolean;
  doctorTableError: any;
  doctorTable: DoctorTableModal[];
}

const initialState: DoctorTableState = {
  doctorTableLoading: false,
  doctorTableSuccess: false,
  doctorTableError: "",
  doctorTable: [],
};

const apiUrl = process.env.BASE_URL;

export const getDoctorData = createAsyncThunk<any>(
  "DoctorTableData/getDoctorTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${apiUrl}/doctors/fetchActive/page/1/limit/5`
      );
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(
          "An Unknown error occurred while getting Doctor data"
        );
      }
    }
  }
);

const doctorTableSlice = createSlice({
  name: "DoctorTable",
  initialState,
  reducers: {
    doctorTableClearSuccess: (state) => {
      state.doctorTableSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDoctorData.pending, (state) => {
        state.doctorTableLoading = true;
        state.doctorTableSuccess = false;
        state.doctorTableError = null;
      })
      .addCase(getDoctorData.fulfilled, (state, action) => {
        state.doctorTableLoading = false;
        state.doctorTableSuccess = true;
        state.doctorTable = action.payload;
      })
      .addCase(getDoctorData.rejected, (state, action) => {
        state.doctorTableLoading = false;
        state.doctorTableError = action.payload;
      });
  },
});


export const { doctorTableClearSuccess } = doctorTableSlice.actions;
export default doctorTableSlice.reducer;
